import { render } from "./WaitingClaimApprovalContainer.vue?vue&type=template&id=8c9c50be"
import script from "./WaitingClaimApprovalContainer.vue?vue&type=script&lang=js"
export * from "./WaitingClaimApprovalContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__